import React from "react";
import { Shield, Wrench, Heart } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Shield,
    title: "Reliable Support",
    description:
      "You've worked hard to build your business. We ensure your website runs smoothly with minimal effort on your part, letting you focus on your business growth.",
    color: "primary",
  },
  {
    icon: Wrench,
    title: "Customized for You",
    description:
      "Every business is unique, and we provide hosting solutions tailored to meet the specific needs of your business, supporting everything from WordPress to custom PHP/mySQL setups.",
    color: "accent",
  },
  {
    icon: Heart,
    title: "Hassle-Free",
    description:
      "Choosing us means joining a place where technical challenges are handled for you, allowing your business to thrive without the technical hassle.",
    color: "primary",
  },
];

export default function Features() {
  return (
    <section id="features" className="h-[180px] flex items-center bg-[#000]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <p className="text-lg sm:text-xl font-semibold uppercase tracking-widest text-[#F49555] mb-3">
            Why Host1Help1?
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-[#fff]">
            We know what we are doing. We will always respond.
          </h2>
        </motion.div>


      </div>
    </section>
  );
}